<template>
    <div class="zbxx">
        <div class="header-container">
            <div class="header-container-box">
                <div class="nav-wrapper">
                    <div class="header1">
                        <div @click="tab(item)" v-for="item in lbfl" :key="item.ccid"
                            :class="item.ccid == ccid ? 'active' : ''">{{
                                item.name }}</div>
                    </div>
                    <div class="header1" v-if="lbfl1.length">
                        <div @click="tab2(item)" :class="item.ccid == ccid2 ? 'active' : ''" v-for="item in lbfl1"
                            :key="item.ccid">{{ item.name }}</div>

                    </div>
                    <div class="header1" v-else></div>
                    <div class="header1" v-if="lbfl2.length">
                        <div @click="tab3(item)" :class="item.ccid == ccid3 ? 'active' : ''" v-for="item in lbfl2"
                            :key="item.ccid">{{ item.name }}</div>
                    </div>
                    <div class="header1" v-else></div>
                </div>
                <div class="search-container">
                    <div style="width: 400px;">已为您找到 <span style="color: rgba(255, 139, 78, 1);">{{ totalRecords }}
                        </span>
                        个内容
                    </div>
                    <div style="margin-left: 150px;"> <el-checkbox v-model="checked" @change="tab4"
                            style="font-size: 12px;">仅看个人购买</el-checkbox></div>
                    <div class="page-mode-input-wrapper">
                        <div class="page-mode-input">
                            <el-input v-model="searchVal" placeholder="请输入搜索内容"></el-input>
                        </div>
                        <div class="input-btn" @click="handleSearch">
                            <i class="el-icon-search input-btn-icon"></i>
                            <span class="input-btn-label">搜索</span>
                        </div>
                    </div>
                    <!-- <div class="change-course-btn" @click="changeCourse">
                    <img src="@/assets/img/qiehuan.png" alt="" class="change-course-img">
                    <span>切换课程</span>
                </div> -->
                </div>
            </div>
        </div>

        <!-- <div v-if="tableData.length > 0" class="table-container">
            <div v-for="(item, key) in tableData" :key="key" class="table-item-wrapper animate">
                <div class="table-img-wrapper">
                    <img :src="item.coverUrl" alt="" class="table-img">
                </div>
                <div class="table-content-wrapper">
                    <div class="table-content">
                        <div class="table-title-wrapper">
                            <div class="table-title">
                                {{ item.title }}
                            </div>
                        </div>
                        <div class="table-brief-wrapper">
                            <div class="table-brief">
                                <div class="table-brief-item">
                                    上次学习：
                                    <span v-if="item.lastWatchTime">{{ item.lastWatchTime }}</span>
                                    <span v-else>未开始</span>
                                </div>
                            </div>
                        </div>
                        <div class="table-brief-wrapper">
                            <div class="table-brief">
                                <div class="table-brief-item">
                                    已学习：{{ item.watchProgress }}%
                                </div>
                            </div>
                            <div class="table-progress-wrapper">
                                <el-progress :percentage="item.watchProgress" color="rgba(79, 121, 237, 0.3);"
                                    :show-text="false" :stroke-width="8"></el-progress>
                            </div>
                        </div>
                    </div>
                    <div class="table-btn-wrapper">
                        <div class="table-btn" @click="viewLive(item)">立即学习</div>
                    </div>
                </div>
            </div>

          
        </div> -->

        <div v-if="tableData.length > 0" class="listData">
            <div class="listData-con">
                <div class="list">
                    <div v-for="(item, key) in tableData" :key="key" class="list-item"
                        :class="{ 'disabled': isshow && isshow.expire == 1 && checked == false }">
                        <div class="item-img"><img :src="item.imageUrl" alt=""></div>
                        <div class="item-con">
                            <div class="con-title"> {{ item.title }}</div>
                            <div class="con-date"> 上次学习：
                                <span v-if="item.lastWatchTime">{{ item.lastWatchTime }}</span>
                                <span v-else>未开始</span>
                            </div>
                            <div class="con-jd"> 已学习：{{ item.watchProgress }}%</div>
                            <div v-if="item.lastWatchTime && item.watchProgress > 0" @click="viewLive(item)"
                                class="con-btn">
                                继续学习 </div>
                            <div v-else @click="viewLive(item)" class="con-btn">立即学习</div>
                        </div>
                        <div class="gq">已过期</div>
                        <div class="mask">
                            <div @click="toqyhy">立即续费</div>
                        </div>
                    </div>
                </div>

                <div class="view-more-btn" v-if="tableData.length > 0 && currentPage < totalPages" @click="viewMore">
                    查看更多
                </div>
                <br> <br>

            </div>
        </div>
        <div v-else class="table-container">
            <div class="table-nodata-wrapper">
                <div class="zwsj">
                    <img style="width: 160px;" src="@/assets/img/nodata.png" alt="">
                    <div style="width: 200px;text-align: center;margin-top: 20px;font-size: 17px;color: #999999">
                        您暂无个人购买的课程哦
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="切换课程" :show-close="true" width="1200px" top="80px" :visible.sync="courseTips"
            class="dialog-container">
            <div class="dialog-content-wrapper">
                <div class="dialog-content">
                    <div v-for="(item, index) in courseList" :key="'course-' + index" class="dialog-course-wrapper">
                        <div class="dialog-course-title">{{ item.name }}</div>
                        <div v-if="item.children.length > 0" class="dialog-course-content-wrapper">
                            <div v-for="(childItem, childIndex) in item.children" :key="'child-' + childIndex"
                                class="dialog-course-item-wrapper" @click="selectCourse(childItem)">
                                <div
                                    :class="activeCourse.id == childItem.id ? 'dialog-course-item-active' : 'dialog-course-item'">
                                    {{ childItem.name }}
                                </div>
                            </div>
                            <div style="clear:both;"></div>
                        </div>
                        <div v-else class="dialog-course-content-wrapper dialog-no-course">您暂无个人购买的课程哦</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    userCompanyInfo,
    getCompanyCourseList,
    getCompanyCourseCategory,
    recordCourseList,
    recordCourseCategoryList,
    updateUserChooseCategory,
    recordCourseUser3CategoryList,
    getCourseDetailIntroduction
} from '@/api/index.js';
export default {
    name: '',
    components: {

    },
    data() {
        return {
            isshow: null,
            checked: false,
            lbfl: [],
            lbfl1: [],
            lbfl2: [], ccid: 0, ccid2: 0, ccid3: 0, activeId: "",
            totalRecords: 0,
            dept: '',
            token: '',
            searchVal: '',
            navList: [
                {
                    id: '0',
                    name: '全部'
                }
            ],
            activeNav: '0',
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            courseTips: false,
            courseList: [],
            activeCourse: {},
            hasChooseCourse: false
        }
    },
    mounted() {
        this.dept = window.localStorage.getItem('dept');
        this.token = window.localStorage.getItem('token');
        this.isshow = JSON.parse(window.localStorage.getItem('gqxx'))
        this.checked = window.localStorage.getItem('LBchecked') ? JSON.parse(window.localStorage.getItem('LBchecked')) : false;

        // this.dept = this.$route.params.dept;
        // this.token = this.$route.params.token;
        // this.getCourseChildren();
        // this.getTabList()
        //注释1111
        // this.getTodept()
        this.getCourseChildren();
        this.getTabList()
    },
    methods: {
        toqyhy() {
            this.$router.push({
                path: '/qyhy'
            })


        },
        getTodept() {

            if (this.token)
                userCompanyInfo({}, { Authorization: this.token, }).then(res => {
                    if (res.code == 200) {
                        localStorage.setItem('TopDeptId', res.data.topDeptId);
                        localStorage.setItem('dept', res.data.deptId)

                    }
                })
        },
        tab(row) {
            this.currentPage = 1;
            this.activeId = row.ccid
            this.ccid = row.ccid

            if (row.secondLevel) {
                this.lbfl1 = row.secondLevel
                this.ccid2 = row.secondLevel[0].ccid;
                if (row.secondLevel[0].thirdLevel) {

                    this.lbfl2 = row.secondLevel[0].thirdLevel
                    this.ccid3 = row.secondLevel[0].thirdLevel[0].ccid;
                } else if (row.secondLevel[0].thirdLevel == undefined) {

                    this.lbfl2 = []
                    this.ccid3 = 0
                }
            } else if (row.secondLevel == undefined) {

                this.lbfl1 = []
                this.lbfl2 = []
                this.ccid2 = 0;
                this.ccid3 = 0
            }
            this.tableData = []
            this.getTableData()
        },
        tab2(row) {
            this.currentPage = 1; this.activeId = row.ccid
            this.ccid2 = row.ccid;
            if (row.thirdLevel) {

                this.lbfl2 = row.thirdLevel
                this.ccid3 = row.thirdLevel[0].ccid;
            } else if (row.thirdLevel == undefined) {
                this.lbfl2 = []
                this.ccid3 = 0
            }
            this.tableData = []
            this.getTableData()
        },
        tab3(row) {
            this.currentPage = 1;
            this.activeId = row.ccid;
            this.ccid3 = row.ccid;
            this.tableData = [];
            this.getTableData()
        },
        tab4() {
            window.localStorage.setItem('LBchecked', this.checked)

            this.currentPage = 1;

            this.tableData = [];
            this.getTableData()
        },
        getTabList() {
            // console.log(localStorage.getItem('TopDeptId'), 'getCompanyCourseCategory_____TopDeptId')
            getCompanyCourseCategory({}, {
                Authorization: this.token,
                DeptId: this.dept,

            }).then(res => {
                if (res.code == 0) {
                    // console.log(res, "获取录播分类数据")
                    var newArr = [
                        {
                            id: '0', ccid: '',
                            name: '全部分类'
                        }
                    ];
                    this.lbfl = [...newArr, ...res.data.categoryList]
                    this.activeId = ''// res.data.categoryList[0].ccid
                    this.ccid = ''//res.data.categoryList[0].ccid
                    console.log(res.data.categoryList[0], 'res.data[0].secondLevel')
                    if (res.data.categoryList[0].secondLevel) {
                        // this.lbfl2 = res.data.categoryList[0].secondLevel
                        // this.lbfl2 = [
                        //     {
                        //         id: '0',
                        //         name: '全部'
                        //     }
                        // ]
                        // this.lbfl3 = [
                        //     {
                        //         id: '0',
                        //         name: '全部'
                        //     }
                        // ]

                    }



                }
            })
        },
        //改版前
        // getTableData() {
        //     recordCourseList({
        //         "categoryId": this.activeNav,
        //         "deptId": this.dept,
        //         "keyword": this.searchVal,
        //         "pageNum": this.currentPage,
        //         "pageSize": 10,
        //         "userId": 0
        //     }, {
        //         Authorization: this.token,
        //         DeptId: this.dept
        //     }).then(res => {
        //         if (res.code == 200) {
        //             var data = res.data.list;
        //             var tableArr = this.tableData;
        //             this.tableData = tableArr.concat(data);
        //             this.totalPages = res.data.totalPages;
        //         }
        //         return;
        //     }).catch(err => {
        //        // console.log(err);
        //     });
        // },
        //改版后
        getTableData() {
            getCompanyCourseList({
                "recordCategory": this.activeId,
                "searchText": this.searchVal,
                "pageNum": this.currentPage,
                "pageSize": 20, type: this.checked ? 2 : 1,
                // "userId": 0
            }, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 0) {
                    var data = res.data.list;
                    var tableArr = this.tableData;
                    this.tableData = tableArr.concat(data);
                    this.totalPages = res.data.totalPages;
                    this.totalRecords = res.data.totalRecords
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        handleNav(target) {
            this.activeNav = target;
            this.currentPage = 1;
            this.tableData = [];
            this.getTableData();
        },
        handleSearch() {
            this.currentPage = 1;
            this.tableData = [];
            this.getTableData();
        },
        viewMore() {
            var currentPage = this.currentPage;
            if (currentPage < this.totalPages) {
                this.currentPage = currentPage + 1;
                this.getTableData();
            } else {
                this.$message({
                    message: '没有更多了',
                    type: 'warning'
                });
            }
        },
        changeCourse() {
            recordCourseCategoryList({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.courseList = res.data;
                    this.courseTips = true;
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        selectCourse(row) {
            this.activeCourse = row;
            updateUserChooseCategory(row.id, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.courseTips = false;
                    this.hasChooseCourse = true;
                    this.getCourseChildren();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
        },
        getCourseChildren() {
            var newArr = [
                {
                    id: '0',
                    name: '全部'
                }
            ];
            recordCourseUser3CategoryList({}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    var data = res.data;
                    this.navList = newArr.concat(data);
                    if (this.hasChooseCourse && this.navList.length > 1) {
                        this.activeNav = this.navList[1]["id"];
                    } else {
                        this.activeNav = '0';
                    }
                    this.currentPage = 1;
                    this.tableData = [];
                    this.getTableData();
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
            var childArr = this.activeCourse.children;
            this.navList = newArr.concat(childArr);
            if (this.hasChooseCourse && this.navList.length > 1) {
                this.activeNav = this.navList[1]["id"];
            } else {
                this.activeNav = '0';
            }
        },
        viewLive(row) {
            // 未预约课程校验
            // if(row.appointmentStatus === 2){
            getCourseDetailIntroduction(row.recordId, {}, {
                Authorization: this.token,
                DeptId: this.dept
            }).then(res => {
                if (res.code == 200) {
                    this.$router.push(`/courseDetail/record-learn/${row.recordId}/${this.dept}/${row.courseType}`);
                } else {
                    this.$message.error(res.msg);
                }
                return;
            }).catch(err => {
                // console.log(err);
            });
            // } else {
            //     this.$router.push(`/courseDetail/record-learn/${row.recordId}/${this.dept}/${row.courseType}`);
            // }
        }
    }
}
</script>

<style scoped>
.zbxx {
    width: 100%;

    margin: 0 auto;
    margin-top: 20px;
    overflow: hidden;
}

.header-container {
    width: 100%;
    margin-top: 16px;
}

.header-container-box {
    width: 1200px;
    margin: 0 auto;
}

.animate {
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.nav-wrapper {
    width: 100%;

}

.table-container {
    background: rgba(250, 250, 250, 1);
}


.nav-item-active {
    float: left;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    height: 36px;
    line-height: 25px;
    margin-right: 30px;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    cursor: pointer;
    margin-bottom: 20px;
}

.nav-item {
    float: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    height: 36px;
    line-height: 25px;
    margin-right: 30px;
    position: relative;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    margin-bottom: 20px;
}

.nav-item:hover {
    cursor: pointer;
    color: #000000;
}

.nav-line-wrapper {
    width: 100%;
    bottom: 0px;
    left: 0px;
    position: absolute;
    display: flex;
    justify-content: center;
    margin-top: 6px;
}

.nav-line {
    width: 22px;
    height: 6px;
    background: #4F79ED;
    border-radius: 3px;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.search-container {
    display: flex;
    justify-content: space-between
}

.page-mode-input-wrapper {
    display: flex;
    width: 500px;
    position: relative;
    top: -5px;
}

.page-mode-input>>>.el-input__inner {
    width: 400px !important;
    height: 38px !important;
    border-radius: 6px 0px 0px 6px !important;
    border: 1px solid #6D94FF !important;
    border-right: 0px !important;
}

.input-btn {
    width: 75px;
    height: 38px;
    background: #6D94FF;
    border-radius: 0px 6px 6px 0px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.input-btn:hover {
    cursor: pointer;
    opacity: 0.8;
}

.input-btn-icon {
    font-size: 13px;
}

.input-btn-label {
    margin-left: 5px;
}

.month-wrapper {
    margin-left: 20px;
    position: relative;
    top: -5px;
}

.month-wrapper>>>.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100px !important;
    cursor: pointer !important;
}

.month-wrapper>>>.el-input__inner {
    border: 0px !important;
    font-size: 14px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #333333 !important;
    padding: 0px !important;
    cursor: pointer !important;
}

.month-wrapper>>>.el-input__prefix {
    display: none !important;
}

.month-icon-wrapper {
    position: absolute;
    right: 0px;
    top: 11px;
}

.month-icon {
    color: #4F79ED;
}

.table-item-wrapper {
    display: flex;
    justify-content: space-between;
    padding-top: 32px;

}

.table-img-wrapper {
    width: 148px;
}

.table-img {
    width: 148px;
    height: 92px;
    border-radius: 5px;
}

.table-content-wrapper {
    flex: 1;
    display: flex;
    justify-content: space-between;
    margin-left: 50px;
    padding-bottom: 40px;
    border-bottom: solid #F0F0F0 1px;
}

.table-btn-wrapper {
    margin-top: 27px;
}

.table-btn {
    width: 108px;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}

.table-btn:hover {
    cursor: pointer;
    background: #3E63EE;
    color: #fff;
}

.table-title-wrapper {
    display: flex;
}

.table-title {
    width: 396px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
}

.table-brief-wrapper {
    margin-top: 16px;
    display: flex;
}

.table-brief-title {
    width: 108px;
    height: 28px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    position: absolute;
    left: 0px;
    top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.table-brief {
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.table-brief-item {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
}

.zwsj {
    width: 160px;
    height: 200px;
    margin: 150px auto;
}

.view-more-btn {
    width: 122px;
    height: 34px;
    border-radius: 20px;
    border: 1px solid #F69264;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #F69568;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;

    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;

}

.view-more-btn:hover {
    cursor: pointer;
    background: #F69264;
    color: #fff;
}

.team-manage-container>>>.el-dialog__body {
    padding: 0px !important;
}

.team-manage-container>>>.el-dialog__header {
    padding: 0px !important;
}

.dialog-header {
    width: 100%;
    height: 59px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
}

.el-dialog__title {
    font-size: 24px !important;
    font-family: PingFangSC-Medium, PingFang SC !important;
    font-weight: 500 !important;
    color: #333333 !important;
}

.dialog-content {
    padding: 0px 0px 60px 20px;
}

.dialog-info {
    text-align: center;
}

.table-progress-wrapper {
    margin-left: 20px;
    width: 324px;
    position: relative;
    top: 11px;
}

.table-nodata-wrapper {
    min-height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.nodata-label {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
    margin-top: 20px;
}

.change-course-btn {
    width: 132px;
    height: 36px;
    border-radius: 6px;
    border: 1px solid #3E63EE;
    margin-left: 30px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: -5px;
}

.change-course-btn:hover {
    cursor: pointer;
}

.change-course-img {
    width: 18px;
    height: 17px;
    margin-right: 5px;
}

.dialog-course-title {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3E63EE;
    margin-bottom: 20px;
}

.dialog-course-item-wrapper {
    width: 25%;
    float: left;
}

.dialog-course-item {
    padding: 10px 20px 10px 20px;
    background: #EDF0FD;
    border-radius: 22px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3E63EE;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    border: solid #EDF0FD 1px;
    margin-bottom: 30px;
    display: inline-block;
    min-width: 166px;
    text-align: center;
}

.dialog-course-item:hover {
    border: solid #3E63EE 1px;
    cursor: pointer;
}

.dialog-course-item-active {
    padding: 10px 20px 10px 20px;
    background: #3E63EE;
    border-radius: 22px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    transition: 0.5s;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
    border: solid #3E63EE 1px;
    margin-bottom: 30px;
    display: inline-block;
    min-width: 166px;
    text-align: center;
    cursor: pointer;
}

.dialog-no-course {
    margin-bottom: 30px;
}

.header1 {

    height: auto;
    display: flex;
    flex-wrap: wrap;
    line-height: 30px;
    margin-bottom: 20px;


}

.header1 div {
    width: auto;
    cursor: pointer;
    margin-right: 30px;
}

.header1 .active {
    color: rgba(15, 108, 245, 1);
}

.listData {
    overflow: hidden;
    margin-top: 10px;
    width: 100%;
    height: 630px;
    background: rgba(250, 250, 250, 1);
    overflow-y: auto;


}

.listData-con {
    width: 1200px;
    height: 100%;
    margin: 0 auto;

}

.list {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
}

.list-item {
    width: 280px;
    height: 347px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 8px;
    border: 1px solid #F0F0F3;
    margin: 5px;
}

.item-img {
    width: 280px;
    height: 158px;
    background: #D8D8D8;
    border-radius: 8px 8px 0px 0px;
    overflow: hidden;
}

.item-img>img {
    width: 100%;
    height: 100%;
}

.item-con {
    width: 248px;
    height: auto;
    margin: 0 auto;
}

.con-title {
    width: 100%;
    margin-top: 10px;
    height: 44px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 22px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 显示两行内容 */
    overflow: hidden;
    margin-bottom: 15px;
}

.con-date {
    width: 100%;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #9B9FAA;
    line-height: 17px;
    margin-bottom: 15px;
}

.con-jd {
    width: 100%;

    height: 20px;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    margin-bottom: 15px;
}

.con-btn {
    cursor: pointer;
    margin-bottom: 15px;
    text-align: center;
    width: 100%;
    color: #0F6CF5;
    height: 32px;
    line-height: 32px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px 0px rgba(149, 154, 170, 0.15);
    border-radius: 2px;
    border: 1px solid #F0F0F3;
}

.con-btn:hover {
    width: 100%;
    height: 32px;
    background: #0F6CF5;
    border-radius: 2px;
    color: #fff;
}

/deep/ .el-checkbox__label {
    font-size: 15px !important;
    font-weight: 400;
    line-height: 40px !important;
}

.disabled {
    position: relative;
}

.disabled:hover .gq {
    display: none;
}

.gq {
    display: none;
}

.disabled .gq {
    display: block;
}

.mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    display: none;
}

.mask div {
    text-align: center;
    width: 200px;
    height: 40px;
    line-height: 40px;
    margin-left: 45px;
    margin-top: 55%;
    background: #000;
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
}

.disabled .con-btn {
    pointer-events: none !important;
    /* 阻止鼠标事件 */
    cursor: no-drop !important;
    /* 鼠标变为禁止标志 */
    background-color: #f0f0f0 !important;
    /* 浅灰色背景 */
    color: #a9a9a9 !important;
    /* 深灰色文本 */
}

.disabled:hover .mask {
    display: inline-block;
}

.disabled>.gq {
    position: absolute;
    padding: 4px 10px;
    background: #626161;
    left: 5px;
    top: 5px;
    border-radius: 5px;
    color: #fff;
}
</style>
